// Popup de produto do totem/balcão: combo × individual, etapas, resumo ou
// produto simples. Estado no hook; cada ramo é um componente com `ctx`.
import DialogoDescartar from "./DialogoDescartar";
import DialogoPesoAlto from "./DialogoPesoAlto";
import TelaComboOuSimples from "./TelaComboOuSimples";
import TelaEtapas from "./TelaEtapas";
import TelaResumo from "./TelaResumo";
import TelaSimples from "./TelaSimples";
import { usePopupProduto } from "./usePopupProduto";

export default function PopupProduto(props) {
  const h = usePopupProduto(props);
  if (!props.product) return null;
  const t = {
    bg: "bg-zinc-900", bgMuted: "bg-zinc-800", bgCard: "bg-zinc-800/80", bgInput: "bg-zinc-700",
    text: "text-zinc-100", textMuted: "text-zinc-400", border: "border-zinc-600",
    selectedBg: "bg-orange-500/20", selectedBorder: "border-orange-500", hoverBorder: "hover:border-orange-400",
  };
  // Os avisos por cima do popup: "Descartar pedido?" e "Confirmar 426,000 kg?".
  const discardConfirmDialog = (<>
    <DialogoDescartar showDiscardConfirm={h.showDiscardConfirm} setShowDiscardConfirm={h.setShowDiscardConfirm} onClose={props.onClose} />
    <DialogoPesoAlto {...h.dialogoPeso} />
  </>);
  // `midias`: fotos extras e vídeo — só o Totem passa (o Balcão não mostra; 23/10/2026)
  const ctx = { ...h, t, discardConfirmDialog, midias: props.midias };
  const { isCombo, hasOrderSteps, comboStep, isOnSummaryStep, totalSteps, relevantSteps } = h;

  if (isCombo && comboStep === 0) return <TelaComboOuSimples ctx={ctx} />;
  if ((isCombo || (!isCombo && hasOrderSteps)) && isOnSummaryStep) return <TelaResumo ctx={ctx} />;
  const mostraEtapas = (isCombo && comboStep > 0 && comboStep <= totalSteps) || (!isCombo && hasOrderSteps && comboStep > 0 && comboStep <= totalSteps);
  if (mostraEtapas && relevantSteps.length > 0) return <TelaEtapas ctx={ctx} />;
  return <TelaSimples ctx={ctx} />;
}
